import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preconnect to image CDN FIRST for faster resource discovery
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://cdn.magicpatterns.com';
preconnect.crossOrigin = 'anonymous';
document.head.appendChild(preconnect);
// Preload hero image (LCP element) — highest priority, before any scripts
const link = document.createElement('link');
link.rel = 'preload';
link.as = 'image';
link.type = 'image/webp';
link.setAttribute('fetchpriority', 'high');
link.setAttribute('imagesizes', '(max-width: 768px) 100vw, 768px');
link.href = 'https://cdn.magicpatterns.com/uploads/vN4PmtBaiFEccxLMF1kWvR/ChatGPT_Image_25_jun_2026,_15_41_14.webp';
document.head.appendChild(link);
// Render app immediately
render(<App data-id="element-320" />, document.getElementById('root'));
// Meta Pixel — initialized exactly ONCE per page load.
// The whole block is guarded by `__metaPixelInit` so that if this module is
// ever evaluated more than once (React StrictMode double-invoke, HMR, or a
// re-mount) we do NOT inject a second pixel script or fire a second PageView.
const _w = window as any;
if (!_w.__metaPixelInit) {
  _w.__metaPixelInit = true;
  if (!_w.fbq) {
    const fbq: any = _w.fbq = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    if (!_w._fbq) _w._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    // Defer injecting the Facebook events library until the browser is idle.
    // The fbq stub above queues init/PageView immediately, and the real
    // library flushes that queue once it loads — so tracking is preserved.
    // Deferring the ~80KB script frees the slow-4G pipe for the hero image
    // (the LCP element), improving mobile load time without any visual change.
    const injectPixel = () => {
      const fbScript = document.createElement('script');
      fbScript.async = true;
      fbScript.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(fbScript);
    };
    const schedule = () => {
      if ('requestIdleCallback' in _w) {
        _w.requestIdleCallback(injectPixel, {
          timeout: 4000
        });
      } else {
        setTimeout(injectPixel, 2500);
      }
    };
    if (document.readyState === 'complete') {
      schedule();
    } else {
      _w.addEventListener('load', schedule, {
        once: true
      });
    }
  }
  _w.fbq('init', '2473048559871614');
  _w.fbq('track', 'PageView');
}
// UTMify pixel — injected exactly ONCE per page load (guarded against
// StrictMode double-invoke / HMR / re-mount so it never double-fires).
if (!_w.__utmifyInit) {
  _w.__utmifyInit = true;
  _w.pixelId = '6a3dcee8cbbd7f1c27e61a89';
  const utmifyInject = () => {
    const a = document.createElement('script');
    a.setAttribute('async', '');
    a.setAttribute('defer', '');
    a.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
    document.head.appendChild(a);
  };
  // Defer to idle so it doesn't compete with the hero image (LCP) on slow 4G.
  const utmifySchedule = () => {
    if ('requestIdleCallback' in _w) {
      _w.requestIdleCallback(utmifyInject, {
        timeout: 4000
      });
    } else {
      setTimeout(utmifyInject, 2500);
    }
  };
  if (document.readyState === 'complete') {
    utmifySchedule();
  } else {
    _w.addEventListener('load', utmifySchedule, {
      once: true
    });
  }
}
// UTMify UTMs tracker — captures UTM params and propagates them to the
// checkout links. Injected exactly ONCE per page load.
if (!_w.__utmifyUtmsInit) {
  _w.__utmifyUtmsInit = true;
  const utmsInject = () => {
    const s = document.createElement('script');
    s.setAttribute('src', 'https://cdn.utmify.com.br/scripts/utms/latest.js');
    s.setAttribute('data-utmify-prevent-xcod-sck', '');
    s.setAttribute('data-utmify-prevent-subids', '');
    s.setAttribute('async', '');
    s.setAttribute('defer', '');
    document.head.appendChild(s);
  };
  const utmsSchedule = () => {
    if ('requestIdleCallback' in _w) {
      _w.requestIdleCallback(utmsInject, {
        timeout: 4000
      });
    } else {
      setTimeout(utmsInject, 2500);
    }
  };
  if (document.readyState === 'complete') {
    utmsSchedule();
  } else {
    _w.addEventListener('load', utmsSchedule, {
      once: true
    });
  }
}